interface ITranslationConstants {
  companyLegalName: string;
  companyName: string;
}

export const heyLightTranslationConstants: ITranslationConstants = {
  companyLegalName: 'HeyLight AG',
  companyName: 'HeyLight',
};
